import type { LDContext } from "launchdarkly-js-client-sdk";

const ldBaseContext = "MY_EZRA";
type IdentifyFunction = (context: LDContext) => Promise<unknown>;

export interface LaunchDarklyUserProfile {
    sub?: string;
    email?: string;
}

export const getLdContext = (): LDContext => {
    return {
        kind: 'application',
        key: ldBaseContext,
    }
}

export const getUserContext = (userId: string, email?: string): LDContext => {
    return {
        kind: 'multi',
        application: {
            key: ldBaseContext,
        },
        user: {
            key: userId,
            ...(email && {
                email,
                _meta: {
                    privateAttributes: ['email'],
                },
            }),
        },
    }
}

export const identifyLaunchDarklyUser = async (
    identify: IdentifyFunction,
    profile: LaunchDarklyUserProfile | undefined,
    errorMessage = "LaunchDarkly identify failed"
): Promise<void> => {
    if (!profile?.sub) {
        return;
    }

    try {
        await identify(getUserContext(profile.sub, profile.email));
    } catch (error) {
        console.error(errorMessage, error);
    }
}

export const identifyLaunchDarklyApplication = (
    identify: IdentifyFunction,
    errorMessage = "LaunchDarkly identify on logout failed"
): void => {
    identify(getLdContext()).catch((error) => console.error(errorMessage, error));
}
